import React from 'react';
import { useBnSnackbar } from '~/common/bn-snackbar-provider';
import { Link, makeStyles, Tooltip, Icons } from '~/lib/bn-material-ui';

const useStyles = makeStyles(() => ({
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
    '& svg': {
      fontSize: '1rem',
    },
  },
}));

export default function BnCopyToClipboard({ children, className, showIcon = false, text }) {
  if (!text && typeof children === 'string') {
    text = children.trim();
  }
  const styles = useStyles();
  const { enqueueSnackbar } = useBnSnackbar();
  return <Link
    underline='none'
    href='#'
    className={className}
    onClick={() => {
      navigator.clipboard.writeText(text);
      enqueueSnackbar(`Copied to clipboard: ${text}`, { variant: 'success' });
    }}>
    <Tooltip title={'Copy to clipboard'}>
      <span className={`${styles.link} ${className}`}>
        { children }
        {showIcon && <Icons.FileCopy />}
      </span>
    </Tooltip>
  </Link>;
}
